import { Capacitor } from "@capacitor/core";
import { apiClient, type ApiClient } from "./client";
import { useUserStore } from "@/stores/user";

let instance: ApiClient | null = null;

export function getApi(): ApiClient {
  if (instance) return instance;
  // Web / PWA: same-origin works (the SPA at app.trans-tech.net hits
  // app.trans-tech.net/api/*). Native (Capacitor iOS/Android) loads the
  // SPA from capacitor://localhost; same-origin would resolve to the local
  // asset shell, not the API, and every request would silently return
  // garbage. Google's first reviewer hit exactly this — "Cannot read
  // properties of undefined (reading 'userId')" on the lead form, and a
  // dead "app not responding" screen because every subsequent call also
  // failed. Native builds must point at the explicit API host.
  let baseUrl = import.meta.env.VITE_API_BASE_URL ?? "";
  if (!baseUrl && Capacitor.isNativePlatform()) {
    baseUrl = "https://api.trans-tech.net";
  }
  instance = apiClient({
    baseUrl,
    getAuthToken: () => {
      const user = useUserStore();
      return user.authToken;
    }
  });
  return instance;
}

export function resetApiForTests() { instance = null; }
